import React, { FC } from 'react';
import {
  TypeLink_external,
  TypeLink_internal,
  TypeListFields,
} from '@/core/generated-types';
import { DynamicComponent, ExternalLink, InternalLink } from '@/components';

interface ListProps extends TypeListFields {
  nestingLevel: number;
}

const List: FC<ListProps> = ({ title, link, listItems, nestingLevel = 1 }) => {
  const hasContent = !!((link && link.sys.contentType.sys.id) || title);
  const divClasses = hasContent
    ? `${nestingLevel > 1 ? 'mb-6 text-sm' : 'mt-6'} mt-6 text-indigo`
    : '';

  return (
    <div>
      <div className={divClasses}>
        {/* Displays a link if present. Otherwise, displays title. */}
        {link && link?.sys?.contentType?.sys?.id === 'link_internal' ? (
          <InternalLink link={link as TypeLink_internal} />
        ) : link?.sys?.contentType?.sys?.id === 'link_external' ? (
          <ExternalLink link={link as TypeLink_external} />
        ) : (
          title
        )}
      </div>
      {listItems?.map((component, index) =>
        component?.sys?.contentType?.sys?.id === 'link_internal' ? (
          <InternalLink
            key={`${component.sys.id}-${index}`}
            link={component as TypeLink_internal}
          />
        ) : component?.sys?.contentType?.sys?.id === 'link_external' ? (
          <ExternalLink
            key={`${component.sys.id}-${index}`}
            link={component as TypeLink_external}
          />
        ) : (
          <DynamicComponent
            key={`${component.sys.id}-${index}`}
            component={component}
            nestingLevel={nestingLevel + 1}
          />
        ),
      )}
    </div>
  );
};

export default React.memo(List);
